import { useState, useRef, useEffect } from 'react';
import {
  Container, Box, Button
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import OTPInput, { ResendOTP } from 'otp-input-react';
import { useSnackbar } from 'notistack';

import { useVerifyCodeMutation } from '../../redux/services/VerifyCode/VerifyCode';
import { useSendCodeForEnrollMutation } from '../../redux/services/SendCodeForEnroll/SendCodeForEnroll';
import { useStyles } from './style';

const convertSecToClockFormat = (timeInSec) => {
  const minutes = Math.floor(timeInSec / 60);
  const seconds = timeInSec - minutes * 60;
  return `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds
    }`;
};

export const PhoneVerification = () => {
  const classes = useStyles();
  const [OTP, setOTP] = useState('');
  const history = useHistory();
  const profile = useSelector((state) => state.profile.profilInfo);
  const [verifyCodeApi, verifyCodeApiInfo] = useVerifyCodeMutation();
  const [sendCodeForEnrollApi, {
    isError: enrollError, isSuccess: enrollSuccess, reset: enrollReset, isLoading
  }] = useSendCodeForEnrollMutation();
  const { enqueueSnackbar } = useSnackbar();
  const errorVerifyCodeApi = useRef(false);
  const errorSendCodeForEnrollApi = useRef(false);

  const renderButton = (buttonProps) => <LoadingButton loading={isLoading} className={classes.resendButtonStyle} disableRipple {...buttonProps}>Resend Code</LoadingButton>;
  const renderTime = (remainingTime) => <Box className={classes.remainingTimeText}>Code will expire in <Box component="span" className={classes.remainingTime}>{convertSecToClockFormat(remainingTime)}</Box></Box>;

  useEffect(() => {
    if (errorSendCodeForEnrollApi.current) {
      enqueueSnackbar('Error in resending OTP !!', { variant: 'error' });
    }
    errorSendCodeForEnrollApi.current = false;
  }, [errorSendCodeForEnrollApi.current]);

  if (enrollSuccess) {
    enrollReset();
  }
  if (enrollError) {
    errorSendCodeForEnrollApi.current = true;
    enrollReset();
  }

  const resendClickHandler = async () => {
    let phOnlyDigits = profile.Phone.replace(/\D/g, '');
    if (phOnlyDigits.length >= 11) {
      phOnlyDigits = phOnlyDigits.substring(1);
    }
    await sendCodeForEnrollApi({
      donorId: profile.Id,
      phoneNumer: phOnlyDigits
    });
  };

  useEffect(() => {
    if (errorVerifyCodeApi.current) {
      if (verifyCodeApiInfo.error.status === 404) {
        enqueueSnackbar('something went wrong!!', { variant: 'error' });
      }
      if (verifyCodeApiInfo.error.status !== 404) {
        enqueueSnackbar('OTP does not match !!', { variant: 'error' });
      }
    }
    errorVerifyCodeApi.current = false;
    verifyCodeApiInfo.reset();
  }, [errorVerifyCodeApi.current]);

  if (verifyCodeApiInfo.isSuccess) {
    if (profile.InsuranceCardPhotoFront && profile.InsuranceCardPhotoBack) {
      history.push('/card-verify');
    } else {
      history.push('/card-view');
    }
    verifyCodeApiInfo.reset();
  }

  if (verifyCodeApiInfo.isError) {
    errorVerifyCodeApi.current = true;
  }

  const nextClickHandler = () => {
    verifyCodeApi({
      donorId: profile.Id,
      code: OTP
    });
  };

  return (
    <Container maxWidth="md" className={classes.phoneVerificationContainer}>
      <Box className={classes.screenContentWrap}>
        <Box className={classes.contentPosition}>
          <Box className={classes.phoneVerificationText}>Phone Verification</Box>
          <Box className={classes.codeInfoText}>A six digit number was just sent to <Box className={classes.codeInfoTextPh} component="div">{profile.Phone}</Box> Please enter the number here to verify your phone number.</Box>
          <Box>
            <OTPInput
              className={classes.codeInputWrap}
              inputClassName={classes.codeInput}
              inputStyles={{ minWidth: '43px', minHeight: '49px', marginRight: '14px' }}
              value={OTP}
              onChange={setOTP}
              autoFocus
              OTPLength={6}
              otpType="number"
              disabled={false}
            />
            <ResendOTP
              renderButton={renderButton}
              renderTime={renderTime}
              maxTime={120}
              autoFocus
              onResendClick={resendClickHandler}
              style={{ flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' }}
            />
            <Button onClick={() => history.push('/sms-not-enrolled')} className={`${classes.resendButtonStyle} ${classes.noNumberAccess}`} disableRipple >I can&apos;t access this number now</Button>
          </Box>
          <Box className={classes.btnContentWrap}>
            <Button className={`${classes.phVeriBtn} ${classes.prevBtn}`} variant="contained" color="secondary" onClick={() => history.push('/emergency-info')}>Back</Button>
            <LoadingButton loading={verifyCodeApiInfo.isLoading} onClick={nextClickHandler} className={`${classes.phVeriBtn} ${classes.nextBtn}`} variant="contained" color="primary" disabled={OTP.length !== 6}>Next</LoadingButton>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};
